<template>
  <v-navigation-drawer
    v-if="drawer"
    fixed
    clipped
    app
  >
    <v-list>
      <template
        v-for="module in modules"
      >
        <v-list-tile
          v-if="!module.hasOwnProperty('items')"
          :key="module.title"
          @click="pushRoute(module.route)"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ module.title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action></v-list-tile-action>
        </v-list-tile>
        <v-list-group
          v-else
          :key="module.title"
          v-model="module.active"
          no-action
        >
          <v-list-tile
            slot="activator"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                {{ module.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <template
            v-for="item in module.items"
          >
            <v-list-tile
              v-if="!item.hasOwnProperty('items')"
              :key="item.title"
              @click="pushRoute(item.route)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action></v-list-tile-action>
            </v-list-tile>
            <v-list-group
              v-else
              :key="item.title"
              no-action
              sub-group
            >
              <v-list-tile
                slot="activator"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.title }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                v-for="subItem in item.items"
                :key="subItem.title"
                @click="pushRoute(subItem.route)"
              >
                <v-list-tile-content>
                  <v-list-tile-title
                    :class="subItem.hasOwnProperty('class') ? `${subItem.class} ml-4` : 'ml-4'"
                  >
                    {{ subItem.title }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { HR_URL, CBCRM_URL } from '~/_shared/consts'
import { mapGetters } from 'vuex'

export default {
  name: 'Navdrawer',

  data () {
    return {
      drawer: true,
      modules: [
        {
          title: 'Production Module',
          active: false,
          items: [
            {
              title: 'PDM',
              active: false,
              items: [
                {
                  title: 'Part Number',
                  verify: false,
                  route: {
                    name: 'product.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Paint Master',
                  verify: false,
                  route: {
                    name: 'paint.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'BOM Master',
                  verify: false,
                  route: {
                    name: 'bom.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Routing',
                  verify: false,
                  route: {
                    name: 'detailing.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Production Matrix',
                  verify: false,
                  route: {
                    name: 'production-matrix.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'Production Control',
              active: false,
              items: [
                {
                  title: 'Work Order',
                  verify: false,
                  route: {
                    name: 'work-order.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Work Order Scheduling',
                  verify: false,
                  route: {
                    name: 'work-order.scheduling',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'MRP',
                  verify: false,
                  route: {
                    name: 'mrp.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Close Work Order',
                  verify: false,
                  route: {
                    name: 'close-work-order.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'Inventory',
              active: false,
              items: [
                {
                  title: 'Packing Slip',
                  verify: false,
                  route: {
                    name: 'packing-slip.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Inventory Receipt',
                  verify: false,
                  route: {
                    name: 'receipt.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Inventory Utilities',
                  verify: false,
                  route: {
                    name: 'utilities.status',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Inventory Transfer',
                  verify: false,
                  route: {
                    name: 'transfer.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Inventory Adjustment',
                  verify: false,
                  route: {
                    name: 'adjustment.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Inventory Count',
                  verify: false,
                  route: {
                    name: 'inventory.count.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Cycle Count',
                  verify: false,
                  route: {
                    name: 'inventory.cycle.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'CSG',
              active: false,
              items: [
                {
                  title: 'Business Partners',
                  verify: false,
                  route: {
                    name: 'partners.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Estimate',
                  verify: false,
                  route: {
                    name: 'estimates.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Blanket',
                  verify: false,
                  route: {
                    name: 'blanket.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Sales Orders',
                  verify: false,
                  route: {
                    name: 'so.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Selling Price',
                  verify: false,
                  route: {
                    name: 'sp.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Return Goods Auth',
                  verify: false,
                  route: {
                    name: 'rga.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Customer Owned Return Goods Auth.',
                  verify: false,
                  route: {
                    name: 'customer-owned-rga.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'Purchasing',
              active: false,
              items: [
                {
                  title: 'Purchase Order',
                  route: {
                    name: 'purchase.order.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Purchase Price',
                  route: {
                    name: 'purchase.price.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Vendor Return',
                  route: {
                    name: 'vendor-return.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'Accounting',
              active: false,
              items: [
                {
                  title: 'List Item',
                  verify: false
                },
                {
                  title: 'Voucher',
                  verify: false,
                  route: {
                    name: 'vouchers.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Invoice',
                  verify: false,
                  route: {
                    name: 'invoices.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'Commissions',
              active: false,
              items: [
                {
                  title: 'Commissions',
                  verify: false,
                  route: {
                    name: 'commissions.commissions.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Sales Rep',
                  verify: false,
                  route: {
                    name: 'commissions.sales_rep.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Commission Vouchers',
                  verify: false,
                  route: {
                    name: 'commissions.voucher.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Variable Tax Rate',
                  verify: false,
                  route: {
                    name: 'commissions.rate.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'Reports',
              active: false,
              items: [
                {
                  title: 'PDM',
                  verify: false,
                  class: 'blue--text',
                  route: {
                    name: 'reports.pdm-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Production Control',
                  verify: true,
                  class: 'blue--text',
                  route: {
                    name: 'reports.production-control-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Inventory',
                  verify: true,
                  class: 'blue--text',
                  route: {
                    name: 'reports.inventory-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'CSG',
                  verify: true,
                  class: 'blue--text',
                  route: {
                    name: 'reports.csg-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Purchasing',
                  verify: true,
                  class: 'blue--text',
                  route: {
                    name: 'reports.purchasing-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Accounting',
                  verify: true,
                  class: 'blue--text',
                  route: {
                    name: 'reports.accounting-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Miscellaneous',
                  verify: true,
                  class: 'blue--text',
                  route: {
                    name: 'reports.miscellaneous-reports',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                }
              ]
            },
            {
              title: 'System',
              active: false,
              items: [
                {
                  title: 'Users',
                  verify: false,
                  route: {
                    name: 'system.admin.users.list',
                    params: {
                      companyId: this.$store.getters['auth/company']
                    }
                  }
                },
                {
                  title: 'Admin Panel',
                  verify: true,
                  route: {
                    path: '/admin',
                    target: '_blank'
                  },
                  class: 'crud-admin-panel'
                }
              ]
            }
          ]
        },
        {
          title: 'HR Module',
          active: false,
          items: [
            {
              title: 'Personal Data',
              active: false,
              route: {
                path: this.hrUrl(false) + '#PersonalDataTab',
                target: '_blank'
              }
            },
            {
              title: 'Attendance / Vacation',
              active: false,
              route: {
                path: this.hrUrl(false) + '#attendanceVacationTab',
                target: '_blank'
              }
            },
            {
              title: 'Announcement',
              active: false,
              route: {
                path: this.hrUrl(true) + '#announcementTab',
                target: '_blank'
              }
            },
            {
              title: 'HR Tools',
              active: false,
              route: {
                path: this.hrUrl(false) + '#hrAdminPanelTab',
                target: '_blank'
              }
            },
            {
              title: 'Organizational Chart',
              active: false,
              route: {
                path: this.hrUrl(false) + '#hrOrgChartTab',
                target: '_blank'
              }
            },
            {
              title: 'Calendar',
              active: false,
              route: {
                path: this.hrUrl(false) + '#calendarTab',
                target: '_blank'
              }
            },
            {
              title: 'IT Asset Management',
              active: false,
              route: {
                path: this.hrUrl(false) + '#assetManagementTab',
                target: '_blank'
              }
            },
            {
              title: 'Help',
              active: false,
              route: {
                path: this.hrUrl(false) + '#helpTab',
                target: '_blank'
              }
            }
          ]
        },
        {
          title: 'CRM Module',
          active: false,
          items: [
            {
              title: 'Journal',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#journalTab',
                target: '_blank'
              }
            },
            {
              title: 'News DropBox',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#newsDropBoxTab',
                target: '_blank'
              }
            },
            {
              title: 'Contacts',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#contactsTab',
                target: '_blank'
              }
            },
            {
              title: 'Opportunity',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#opportunityTab',
                target: '_blank'
              }
            },
            {
              title: 'Forecast',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#forecastTab',
                target: '_blank'
              }
            },
            {
              title: 'Meeting Planner',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#calendarTab',
                target: '_blank'
              }
            },
            // {
            //   title: 'Expenses',
            //   verify: true,
            //   route: {
            //     path: this.crmUrl(true) + '#expencesTab',
            //     target: '_blank'
            //   }
            // },
            {
              title: 'Project Planner',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#projectPlannerTab',
                target: '_blank'
              }
            },
            {
              title: 'Time Management',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#timeManagementTab',
                target: '_blank'
              }
            },
            {
              title: 'News Room',
              verify: true,
              route: {
                path: this.crmUrl(true) + '#newsRoomTab',
                target: '_blank'
              }
            }
          ]
        },
        {
          title: 'TASK Module',
          active: false,
          route: {
            path: this.crmUrl(true) + '#tasksTab',
            target: '_blank'
          }
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      company: 'auth/company',
      userPermissionsAndActionTasks: 'permission/userPermissionsAndActionTasks',
      user: 'auth/user'
    })
  },

  async created () {
    await this.$store.dispatch('permission/fetchUserPermissionsAndActionTasks', { company: this.$store.getters['auth/company'] })
    setTimeout(() => {
      let _items = this.items

      for (let i in _items) {
        _items[i].active = this.isActive(_items[i].items)
      }

      this.items = _items
    }, 100)
  },
  methods: {
    toggleDrawer () {
      this.drawer = !this.drawer
    },
    isActive (items) {
      let active = false

      for (let i in items) {
        let item = items[i]
        if (item.hasOwnProperty('route') && !active) {
          active = (item.route.name === this.$route.name)
        }
      }

      return active
    },

    pushRoute (route) {
      if (route.hasOwnProperty('target') && route.target === '_blank') {
        window.open(route.path, '_blank')
      } else {
        this.$router.push(route)
      }
    },

    crmUrl (addToken) {
      if (addToken) {
        const token = localStorage.getItem('crmToken')
        return CBCRM_URL + '?token=' + token
      }
      return CBCRM_URL
    },

    hrUrl (addToken) {
      if (addToken) {
        const token = localStorage.getItem('crmToken')
        return HR_URL + '?token=' + token
      }
      return HR_URL
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/Navdrawer.vue